import { useSchedules } from "@/features/annotation/lib/useSchedules";
import { usePlanogramQuery } from "@/shared/api";
import { PlanogramMesh } from "./planogram-mesh";

export function Planogram({
  selectedGondolas,
  onGondolaSelect,
}: {
  selectedGondolas: string[];
  onGondolaSelect: React.Dispatch<React.SetStateAction<string[]>>;
}) {
  const { activeSchedule } = useSchedules({ queryKey: "planogramSchedules" });
  const { data: planogram } = usePlanogramQuery(
    { id: activeSchedule?.id as number },
    { skip: !activeSchedule }
  );

  return (
    <group position={[0, 1, 0]}>
      {planogram?.result.gondolas.map((gondola) => (
        <PlanogramMesh
          label={gondola.name}
          key={gondola.id}
          active={selectedGondolas.includes(gondola.name)}
          vertices={
            gondola.vertices
              ?.map((vertex) => [vertex[0], vertex[2], -vertex[1]])
              ?.flatMap((v) => v) || []
          }
          onActiveChange={(active, isMulti) => {
            onGondolaSelect((current) => {
              if (!isMulti) return active ? [gondola.name] : [];
              if (active && current.indexOf(gondola.name) < 0)
                return [...current, gondola.name];
              return current.filter((name) => name !== gondola.name);
            });
          }}
          faces={gondola.faces?.flatMap((face) => face) || []}
        />
      ))}
    </group>
  );
}
